angular.module('app.factories').factory('utils', () => ({
    // Util for finding an object by its 'id' property among an array
    findByItemId(a, id) {
        for (let i = 0; i < a.length; i++) {
            if (a[i].item_id == id) return a[i];
        }
        return null;
    },

    // serialize form
    serializeObject(form) {
        const o = {};
        const a = form.serializeArray();
        $.each(a, () => {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    },

    // high density test
    isHighDensity() {
        return (
            (window.matchMedia &&
                (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches ||
                    window.matchMedia(
                        'only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)'
                    ).matches)) ||
            (window.devicePixelRatio && window.devicePixelRatio > 1.3)
        );
    },

    // touch device test
    isTouchDevice() {
        return !!('ontouchstart' in window);
    },

    // local storage test
    lsTest() {
        const test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    },

    // show/hide card
    card_show_hide(card, begin_callback, complete_callback, callback_element) {
        $(card)
            .velocity(
                {
                    scale: 0,
                    opacity: 0.2,
                },
                {
                    duration: 400,
                    easing: [0.4, 0, 0.2, 1],
                    // on begin callback
                    begin() {
                        if (typeof begin_callback !== 'undefined') {
                            begin_callback(callback_element);
                        }
                    },
                    // on complete callback
                    complete() {
                        if (typeof complete_callback !== 'undefined') {
                            complete_callback(callback_element);
                        }
                    },
                }
            )
            .velocity('reverse');
    },
}));
